import React, { Component } from "react";
// 接口以及调用接口方法
import { successQry } from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";
// icon
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
// 组件
import SuccessRateBar from "@/pages/displayBoard/successRateBar";

// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

@connect((state) => state)
class ChargSuccess extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      param: {
        cityIds: this.props.param.cityIds,
        provinceIds: this.props.param.provinceIds, // 默认 000000全国
        date: this.props.param.date,
        operationProperty: this.props.param.operationProperty,
        operationMode: this.props.param.operationMode,
      },
      queryDate: {
        failureOrder: 0,
        failureOrderChain: 0,
        successOrder: 0,
        successOrderChain: 0,
        successRate: 0,
        successRateChain: 0,
        totalOrder: 0,
        totalOrderChain: 0,
      },
    };
  }

  // 父组件修改param时执行
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.param.provinceIds === this.state.param.provinceIds
      && nextProps.param.cityIds === this.state.param.cityIds
      && nextProps.param.operationProperty === this.state.param.operationProperty
      && nextProps.param.operationMode === this.state.param.operationMode
      && nextProps.param.date === this.state.param.date
    ) {
      console.log("一样");
    } else {
      console.log("不一样");
      this.setState(
        {
          param: {
            cityIds: nextProps.param.cityIds,
            provinceIds: nextProps.param.provinceIds, // 默认 000000全国
            date: nextProps.param.date,
            operationProperty: nextProps.param.operationProperty,
            operationMode: nextProps.param.operationMode,
          },
        },
        () => {
          // 获取数据
          this.getSuccessRate();
        },
      );
    }
  }

  // 页面加载前获取充电成功率数据
  componentWillMount() {
    this.getSuccessRate();
  }

  // 获取数据
  getSuccessRate() {
    // 获取成功率数据1
    fetchHandler(successQry, {
      startTime: this.state.param.date,
      cityIds: this.state.param.cityIds,
      operationMode: this.state.param.operationMode,
      operationProperty: this.state.param.operationProperty,
      provinceIds: this.state.param.provinceIds,
    }).then((res) => {
      if (res.data) {
        this.setState({
          queryDate: {
            failureOrder: res.data.failureOrder,
            failureOrderChain: res.data.failureOrderChain,
            successOrder: res.data.successOrder,
            successOrderChain: res.data.successOrderChain,
            successRate: res.data.successRate,
            successRateChain: res.data.successRateChain,
            totalOrder: res.data.totalOrder,
            totalOrderChain: res.data.totalOrderChain,
          },
        });
        this.props.getSuccessRate(res.data.successRate);
      }
    });
  }

  render() {
    // 总订单环比样式值
    let allClassName = '';
    if (this.state.queryDate.totalOrderChain === 0) {
      allClassName = 'item-rate none';
    } else if (this.state.queryDate.totalOrderChain > 0) {
      allClassName = 'down-out-line item-rate';
    } else {
      allClassName = 'down-up-line item-rate';
    }

    // 成功率环比样式值
    let sucClassName = '';
    if (this.state.queryDate.successRateChain === 0) {
      sucClassName = 'item-rate none';
    } else if (this.state.queryDate.successRateChain > 0) {
      sucClassName = 'down-out-line item-rate';
    } else {
      sucClassName = 'down-up-line item-rate';
    }

    // 成功订单环比样式值
    let sucOrderClassName = '';
    if (this.state.queryDate.successOrderChain === 0) {
      sucOrderClassName = 'item-rate none';
    } else if (this.state.queryDate.successOrderChain > 0) {
      sucOrderClassName = 'down-out-line item-rate';
    } else {
      sucOrderClassName = 'down-up-line item-rate';
    }

    // 失败订单环比样式值
    let failClassName = '';
    if (this.state.queryDate.failureOrderChain === 0) {
      failClassName = 'item-rate none';
    } else if (this.state.queryDate.failureOrderChain > 0) {
      failClassName = 'down-out-line item-rate';
    } else {
      failClassName = 'down-up-line item-rate';
    }
    const content = (
      <div
        className="board-inner"
        style={{ height: "100%", display: "flex", flexDirection: "column" }}
      >
        <div className="order-part">
          <div className="order-item">
            <div className="item-title">总订单(笔)</div>
            <div className="item-num">{this.state.queryDate.totalOrder}</div>
            <div
              className={allClassName}
            >
              环比
              <span className="rate-num">
                {
                this.state.queryDate.totalOrderChain === 0
                  ? "--"
                  : `${Math.abs(this.state.queryDate.totalOrderChain)}%`
                }
                {
                this.state.queryDate.totalOrderChain > 0 ? <ArrowUpOutlined /> : null
                }
                {
                this.state.queryDate.totalOrderChain < 0 ? <ArrowDownOutlined /> : null
                }
              </span>
            </div>
          </div>
          <div className="order-item">
            <div className="item-title">成功率</div>
            <div className="item-num">{this.state.queryDate.successRate}%</div>
            <div
              className={sucClassName}
            >
              环比
              <span className="rate-num">
                {
                this.state.queryDate.successRateChain === 0
                  ? "--"
                  : `${Math.abs(this.state.queryDate.successRateChain)}%`
                }
                {
                this.state.queryDate.successRateChain > 0 ? <ArrowUpOutlined /> : null
                }
                {
                this.state.queryDate.successRateChain < 0 ? <ArrowDownOutlined /> : null
                }
              </span>
            </div>
          </div>
          <div className="order-item">
            <div className="item-title">成功订单(笔)</div>
            <div className="item-num">{this.state.queryDate.successOrder}</div>
            <div
              className={sucOrderClassName}
            >
              环比
              <span className="rate-num">
                {
                  this.state.queryDate.successOrderChain === 0
                    ? "--"
                    : `${Math.abs(this.state.queryDate.successOrderChain)}%`
                }
                {
                  this.state.queryDate.successOrderChain > 0 ? <ArrowUpOutlined /> : null
                }
                {
                  this.state.queryDate.successOrderChain < 0 ? <ArrowDownOutlined /> : null
                }
              </span>
            </div>
          </div>
          <div className="order-item">
            <div className="item-title">失败订单(笔)</div>
            <div className="item-num">{this.state.queryDate.failureOrder}</div>
            <div
              className={failClassName}
            >
              环比
              <span className="rate-num">
                {
                  this.state.queryDate.failureOrderChain === 0
                    ? "--"
                    : `${Math.abs(this.state.queryDate.failureOrderChain)}%`
                }
                {
                  this.state.queryDate.failureOrderChain > 0 ? <ArrowUpOutlined /> : null
                }
                {
                  this.state.queryDate.failureOrderChain < 0 ? <ArrowDownOutlined /> : null
                }
              </span>
            </div>
          </div>
        </div>
        <div className="line-title">近7天充电成功率趋势</div>
        <div
          className="line-part"
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
          }}
        >
          <SuccessRateBar param={this.state.param} />
        </div>
      </div>
    );

    return content;
  }
}

export default injectIntl(ChargSuccess);



// WEBPACK FOOTER //
// ./src/AntD/pages/displayBoard/chargSuccess.js